import { defineComponent, openBlock, createElementBlock, createElementVNode, withModifiers, toDisplayString, createVNode, unref, createTextVNode, createCommentVNode, normalizeClass } from "vue";
import { CdrRating } from "@rei/cedar";
const _hoisted_1 = {
  class: "ugc-image-product-tile"
};
const _hoisted_2 = {
  class: "ugc-image-product-tile__image-container"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  class: "ugc-image-product-tile__info"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "ugc-image-product-tile__brand"
};
const _hoisted_8 = {
  class: "ugc-image-product-tile__name"
};
const _hoisted_9 = {
  key: 0,
  class: "ugc-image-product-tile__price ugc-image-product-tile__price--sale"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UgcImageViewerProductTile",
  props: {
    src: {},
    brand: {},
    name: {},
    reviewSummary: {
      default: () => ({
        rating: 0,
        count: 0
      })
    },
    price: {},
    link: {},
    productId: {}
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    function handleLink(event) {
      emit("metricsClick", {
        linkName: "ugc_product link",
        link: props.link,
        event
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("a", {
        href: _ctx.link,
        class: "ugc-image-product-tile__link",
        onClick: _cache[0] || (_cache[0] = withModifiers(($event) => handleLink($event), ["stop"]))
      }, [createElementVNode("img", {
        src: _ctx.src,
        alt: _ctx.name,
        class: "ugc-image-product-tile__image"
      }, null, 8, _hoisted_4)], 8, _hoisted_3)]), createElementVNode("div", _hoisted_5, [createElementVNode("a", {
        href: _ctx.link,
        class: "ugc-image-product-tile__link",
        onClick: handleLink
      }, [createElementVNode("span", _hoisted_7, toDisplayString(_ctx.brand), 1), createElementVNode("span", _hoisted_8, toDisplayString(_ctx.name), 1)], 8, _hoisted_6), createVNode(unref(CdrRating), {
        size: "small",
        compact: true,
        rating: _ctx.reviewSummary.rating,
        count: _ctx.reviewSummary.count
      }, null, 8, ["rating", "count"]), _ctx.price.saleDisplay ? (openBlock(), createElementBlock("span", _hoisted_9, [createTextVNode(" $" + toDisplayString(_ctx.price.saleDisplay) + "  ", 1), _cache[1] || (_cache[1] = createElementVNode("span", {
        class: "pdp-sr-only"
      }, "Compared to", -1))])) : createCommentVNode("", true), createElementVNode("span", {
        class: normalizeClass(["ugc-image-product-tile__price", {
          "ugc-image-product-tile__price--compare": _ctx.price.isOnSale
        }])
      }, " $" + toDisplayString(_ctx.price.display), 3)])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=UgcImageViewerProductTile2.mjs.map
